import { Stack, Text, StackProps } from "@chakra-ui/react";
import { ReactNode } from "react";

export type SectionTitleProps = {
  title: string;
  isRequired?: boolean;
  titlePaddingProps?: {
    pt?: StackProps["pt"];
    pb?: StackProps["pb"];
    pl?: StackProps["pl"];
    pr?: StackProps["pr"];
  };
  description?: ReactNode;
  icon: ReactNode;
  isTitleRow?: boolean;
};

export const SectionTitle = ({
  title,
  isRequired,
  description,
  titlePaddingProps = { pb: "16px", pt: { base: "32px", md: "40px" } },
  icon,
  isTitleRow,
}: SectionTitleProps) => (
  <Stack
    direction={{ base: isTitleRow ? "row" : "column", md: "row" }}
    justify="space-between"
    align={{ base: isTitleRow ? "center" : "flex-start", md: "center" }}
    w="100%"
    gap={0.5}
    spacing={0.5}
    {...titlePaddingProps}
  >
    <Stack direction="row" align="center">
      {icon}
      <Text fontSize="16px" fontWeight="bold" lineHeight="18px">
        {title}
        {isRequired && "*"}
      </Text>
    </Stack>
    {description && description}
  </Stack>
);
